<template>
    <span :class="className">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4773 3.39903C14.7968 3.66263 14.8421 4.13533 14.5785 4.45485L6.32853 14.4548C6.19297 14.6192 5.99393 14.7181 5.78109 14.7269C5.56826 14.7357 5.36171 14.6537 5.213 14.5011L1.463 10.655C1.17384 10.3584 1.17985 9.88357 1.47643 9.59441C1.773 9.30524 2.24784 9.31125 2.537 9.60783L5.70344 12.8555L13.4215 3.50027C13.6851 3.18076 14.1578 3.13543 14.4773 3.39903Z" fill="#fff"/>
</svg>
        
     </span>
</template>

<script>
export default {
    name: 'TickIcon',
    props: {
    width: {
      type: String,
      default: '16px'
    },
    height: {
      type: String,
      default: '16px'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Add any custom styles here */
</style>